<template>
  <v-row v-if="allowed">
    <v-col>
      <div v-for="(element, index) in lists.data" :key="element" :id="element.id">
        <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
          <canvas :class="uuid" :id="uuid+'_'+index" :style="`width: ${size.width}; height: ${size.height};`" />
        </div>
      </div>
    </v-col>
    <v-col cols="3">
      <div :id="uuid+'_legend'" style="max-width: 300px">
        <div v-for="(element, index) in types" :key="element" class="mb-1">
          <v-avatar :color="palette[index]" size="30">
            <span style="font-size: 10px; z-index: 2; font-weight: bold;" :style="`color: ${Colorize(palette[index])}`">{{ element.name }}</span>
          </v-avatar>
          <span style="margin-left: -3px; padding-left: 10px; z-index: 1" :style="`border-bottom: 1px solid ${palette[index]}`">{{ element }}</span>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from "chart.js/auto";
import {Colorize, palette} from "@/libs/colorizer";

export default {
  name: "7dfb247e-0d48-11eb-8114-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  watch: {
    report_data() {
      this.update_charts()
    }
  },
  data() {
    return {
      charts: [],
      allowed: false,
      range: {
        min: 0,
        max: 0,
        middle: 0
      },
      types: [],
      lists: {
        objects: [],
        data: [],
        maximums: {
          small: 0,
          big: 0
        }
      }
    }
  },
  beforeMount() {
    this.init_charts()
  },
  mounted() {
    this.create_charts()
  },
  computed: {
    palette() {
      return palette
    },
    report_data() {
      return this.chart.report_data
    }
  },
  methods: {
    create_charts: function () {
      for (let [index, object] of this.lists.data.entries()) {
        this.create_chart(object, index)
      }
    },
    clear_data: function () {
      this.allowed = false
      this.range = {
        min: 0,
        max: 0,
        middle: 0
      }
      this.types = []
      this.lists = {
        objects: [],
        data: [],
        maximums: {
          small: 0,
          big: 0
        }
      }
    },
    update_charts: function () {
      this.clear_data()
      for (let chart of this.charts) {
        chart.destroy()
      }
      this.charts = []
      this.init_charts()
      setTimeout(() => {
        this.create_charts()
      }, 100)
    },
    getDatasets: function (object) {
      let datasets = []
      let index = 0
      object.works.forEach(work => {
        datasets.push({
          index: index,
          label: work.name,
          data: [work.planned, work.actual]
        })
        index++
      })
      return datasets
    },
    create_chart: function (object, pos) {
      let ctx = document.getElementById(this.uuid+'_'+pos).getContext('2d');
      let chart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['План', 'Факт'],
          datasets: this.getDatasets(object)
        },
        options: {
          indexAxis: 'y',
          plugins: {
            title: {
              display: true,
              text: ' '+object.name,
              align: 'start',
              padding: {
                top: 0,
                bottom: 0
              }
            },
            datalabels: {
              color: function (value) {
                return Colorize(value.dataset.backgroundColor)
              },
              font: {
                size: 8,
              },
              anchor: 'center',
              clamp: true,
              formatter: function (value) {
                if (value > 0) return Math.ceil(value)
                return null
              }
            },
            legend: {
              display: false
            }
          },
          scales: {
            x: {
              ticks: {
                display: true,
                color: '#bebebe',
                font: {
                  size: 7,
                }
              },
              stacked: true,
              min: 0,
              max: object.isBig ? this.lists.maximums.big : this.lists.maximums.small
            },
            y: {
              stacked: true,
              ticks: {
                display: true,
                font: {
                  size: 9,
                }
              },
              beginAtZero: true
            }
          }
        }
      })
      this.charts.push(chart)
    },
    Colorize,
    checkBiggity: function (data) {
      let big = false
      for (let element of data) {
        let bebe = 0
        this.chart.report_data.filter(el => el['Объект'] === element['Объект'] && el['Вид'] === element['Вид']).forEach(el => {
          bebe += el['КоличествоЧеловекоЧасов'] ? el['КоличествоЧеловекоЧасов'] : 0
        })
        if (bebe > this.range.middle) {
          big = true
        }
      }
      return big
    },
    generateTypes: function (data) {
      let array = []
      for (let type of this.types) {
        array.push({
          name: type,
          planned: 0,
          actual: 0
        })
      }
      for (let element of data) {
        let position = array.find(el => el.name === element['ТипРаботПРЕДСТАВЛЕНИЕ'])
        if (position) {
          if (element['Вид'] === 'План') {
            position.planned = element['КоличествоЧеловекоЧасов']
          } else if (element['Вид'] === 'Факт') {
            position.actual = element['КоличествоЧеловекоЧасов']
          }
        }
      }
      return array
    },
    init_charts: function () {
      this.allowed = false
      // Формируем список типов работ и находим максимальное значение
      for (let element of this.chart.report_data) {
        if (element['ТипРаботПРЕДСТАВЛЕНИЕ'] && !this.types.includes(element['ТипРаботПРЕДСТАВЛЕНИЕ'])) {
          this.types.push(element['ТипРаботПРЕДСТАВЛЕНИЕ'])
        }
        if (element['КоличествоЧеловекоЧасов'] > this.range.max) {
          this.range.max = element['КоличествоЧеловекоЧасов']
        }
      }
      // Находим минимальное значение
      this.range.min = this.range.max
      for (let element of this.chart.report_data) {
        if (element['КоличествоЧеловекоЧасов'] && element['КоличествоЧеловекоЧасов'] < this.range.min) {
          this.range.min = element['КоличествоЧеловекоЧасов']
        }
      }
      // Находим математическю середину между числами
      this.range.middle = Math.ceil((this.range.max + this.range.min)/2)

      // Формируем список объектов
      for (let element of this.chart.report_data) {
        if (!this.lists.objects.includes(element['ОбъектПРЕДСТАВЛЕНИЕ'])) {
          this.lists.objects.push(element['ОбъектПРЕДСТАВЛЕНИЕ'])
        }
      }

      // Формируем список данных по объектам
      for (let object of this.lists.objects) {
        let data = this.chart.report_data.filter(el => el['ОбъектПРЕДСТАВЛЕНИЕ'] === object)
        this.lists.data.push({
          id: '7dfb247e-0d48-11eb-8114-00155d01060e_'+this.chart.report_data.find(el => el['ОбъектПРЕДСТАВЛЕНИЕ'] === object)['Объект'],
          name: object,
          isBig: this.checkBiggity(data),
          works: this.generateTypes(data)
        })
      }

      // Добавляем индексы к сортированным данным
      for (let [index, data] of this.lists.data.entries()) {
        data.index = index
        data.isFirst = 0 === index ? true : false
        data.isLast = this.lists.data.length-1 === index ? true : false
      }

      // Находим 2 последних эелемента в большом и маленьком диапазонах
      let smalls = this.lists.data.filter(el => !el.isBig)
      let biggs = this.lists.data.filter(el => el.isBig)
      for (let [index, data] of smalls.entries()) {
        data.firstOfSection = 0=== index ? true : false
        data.lastOfSection = smalls.length-1 === index ? true : false
      }
      for (let [index, data] of biggs.entries()) {
        data.firstOfSection = 0 === index ? true : false
        data.lastOfSection = biggs.length-1 === index ? true : false
      }

      // Находим максимумы для 2 типов: "Большие" и "Небольшие"
      for (let element of this.lists.data) {
        if (!element.isBig) {
          let summ = 0
          element.works.forEach(el => summ += el.planned)
          if (summ > this.lists.maximums.small) this.lists.maximums.small = Math.ceil(summ / 5) * 5
          if (summ > this.range.middle) element.isBig = true
          summ = 0
          element.works.forEach(el => summ += el.actual)
          if (summ > this.lists.maximums.small) this.lists.maximums.small = Math.ceil(summ / 5) * 5
          if (summ > this.range.middle) element.isBig = true
        } else {
          let summ = 0
          element.works.forEach(el => summ += el.planned)
          if (summ > this.lists.maximums.big) this.lists.maximums.big = Math.ceil(summ / 5) * 5
          summ = 0
          element.works.forEach(el => summ += el.actual)
          if (summ > this.lists.maximums.big) this.lists.maximums.big = Math.ceil(summ / 5) * 5
        }
      }

      // Сортируем сначала мелкие, потом большие
      this.lists.data = this.lists.data.sort((a, b) => {
        return (a.isBig === b.isBig)? 0 : a.isBig? 1 : -1;
      });

      // Разрешаем построение графиков
      this.allowed = true
    }
  }
}
</script>

<style scoped>
.object-name {
  color: #666666;
}
.object-legend {

}
</style>